export const versions = {
  version: "1.0.183",
  revision: "92fae6ec6",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5022-g92fae6ec6-dirty",
    hash: "g92fae6ec6",
    distance: 5022,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5022-g92fae6ec6-dirty",
    semverString: "1.0.183+5022.g92fae6ec6.dirty"
  }
};
